import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

const NavBar: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setExpanded(false);
  };

  const closeMenu = () => {
    setExpanded(false);
  };

  return (
    <Navbar expand="lg" fixed="top" className="navbar-floating" expanded={expanded} onToggle={setExpanded}>
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" onClick={closeMenu}>
          <img
            src="/assets/pupnet-logo-filled.png"
            alt="PupNet Logo"
            height="50"
            className="d-inline-block align-top me-2"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={closeMenu}>Home</Nav.Link>
            <Nav.Link as={Link} to="/breeds" onClick={closeMenu}>Breeds</Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={closeMenu}>About</Nav.Link>
            {isAuthenticated && (
              <Nav.Link as={Link} to="/upload" onClick={closeMenu}>Upload</Nav.Link>
            )}
          </Nav>
          <Nav>
            {isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/profile" onClick={closeMenu}>
                  {user?.username}
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" onClick={closeMenu}>Login</Nav.Link>
                <Nav.Link as={Link} to="/register" onClick={closeMenu}>Register</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
